var render = function render(){var _vm=this,_c=_vm._self._c;return _c('standard-container',{attrs:{"title":"Error 404","description":"","icon":"mdi-error"}},[_vm._v(" Pagina non esistente ")])
}
var staticRenderFns = []

export { render, staticRenderFns }